import React, { MouseEventHandler, ReactNode } from 'react';
import { styles } from './CarouselLeadBrand.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { ProductCarousel, ProductCarouselProps } from '../ProductCarousel/ProductCarousel';
import { useTrackingContext } from '../Tracking';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';

export type CarouselLeadBrandProps = {
  brandImage?: ReactNode;
  linkProps?: GoToLinkProps;
  calloutBtn?: ReactNode;
  heading: string;
  subText?: string;
  isWhiteSubText?: boolean;
  productCarouselProps: ProductCarouselProps;
};

export const CarouselLeadBrand = ({
  brandImage,
  heading,
  subText,
  isWhiteSubText,
  productCarouselProps,
  linkProps,
  calloutBtn,
}: CarouselLeadBrandProps) => {
  const { tracker } = useTrackingContext();
  if (!tracker.isEmpty) {
    tracker.group = heading ?? tracker.group;
  }

  const handleCtaClick: MouseEventHandler<HTMLAnchorElement> = e => {
    tracker.trackClick({ label: linkProps?.label, extraData: { moduleName: 'Carousel lead brand CTA' } });
    linkProps?.onClick?.(e);
  };

  return (
    <div className={styles.wrapper}>
      {linkProps ? <GoToLink {...linkProps} className={styles.link} onClick={handleCtaClick} /> : null}
      <div className={styles.container}>
        <div className={styles.leadContainer}>
          {brandImage ? <div className={styles.brandImage}>{brandImage}</div> : null}
          <DomFont className={styles.heading} as="h2">
            {heading}
          </DomFont>
          {subText ? <p className={styles.subText({ isWhiteSubText })}>{subText}</p> : null}
          {calloutBtn ? <div className={styles.calloutBtnDesktop}>{calloutBtn}</div> : undefined}
        </div>
        <div className={styles.carouselContainer}>
          <ProductCarousel {...productCarouselProps} />
        </div>
      </div>
      {calloutBtn ? <div className={styles.calloutBtn}>{calloutBtn}</div> : undefined}
    </div>
  );
};
